import { render, staticRenderFns } from "./ReviewAskEntryCardPc.vue?vue&type=template&id=59fd6a48&scoped=true"
import script from "./ReviewAskEntryCardPc.vue?vue&type=script&lang=js"
export * from "./ReviewAskEntryCardPc.vue?vue&type=script&lang=js"
import style0 from "./ReviewAskEntryCardPc.vue?vue&type=style&index=0&id=59fd6a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd6a48",
  null
  
)

export default component.exports